import './sections.css'

export default function ProjectsSection() {
  return (
    <section className="section" id="projects">
      <div className="section-inner">
        <p className="section-label">Selected works</p>
        <h2 className="section-heading">
          Projects from<br />the void
        </h2>
        <p className="section-desc">
          Each work lives in three-dimensional space — floating exhibits
          in a digital museum. Scroll to let them emerge from darkness.
        </p>
      </div>
    </section>
  )
}
